<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-6 truncate">
            Annulus Pressure Records
        </div>

        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-4">
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': selectedActType == 'General'}"
                (click)="toggleActType('General')">
                General
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': selectedActType == 'CDFT'}"
                (click)="toggleActType('CDFT')">
                CDFT
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': selectedActType == 'Schedule'}"
                (click)="toggleActType('Schedule')">
                Schedule
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': selectedActType == 'pi'}"
                (click)="toggleActType('pi')">
                PI Server
            </a>
        </div>

        <form [formGroup]="searchForm">
            <app-table-filter [searchForm]="searchForm" class="text-primary"
                (searchTriggered)="handleSearch($event)"></app-table-filter>

            <div class="grid grid-cols-1 sm:grid-cols-3">
                <div class="flex justify-start col-span-2">
                    <div class="w-19 ml-2">
                        <mat-form-field class="w-full no-bottom-gap mb-2">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                                <mat-option [value]="50"> 50 </mat-option>
                                <mat-option [value]="100"> 100 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                        (apply)="applySort($event)">
                    </app-sort-menu>

                    <button class="btn btn-outline btn-default dt-download" matTooltip="Download Records"
                        (click)="downloadOverallApr()">
                        <mat-icon class="text-primary hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                    </button>
                </div>
                <div class="flex justify-end">
                    <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                        Search
                    </button>
                    <button class="btn btn-outline btn-default" (click)="reset()">
                        Reset
                    </button>
                    <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                        (click)="setPage({ offset: dt.page.offset})">
                        <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                    </button>
                </div>

                <div class="flex justify-start col-span-2">
                    <span class="self-center font-medium text-gray-400 italic text-md p-2">
                        Sorting by {{ sortInfo }}
                    </span>
                </div>

                <div class="flex justify-end">
                    <span class="self-center font-medium text-primary text-md p-2">
                        {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
                </div>
            </div>
        </form>

        <div class="overflow-x-auto">
            <ng-container *ngIf="selectedActType != 'pi'">
                <apr-table #ngxDatatable [dt]="dt" [startingIndex]="startingIndex" [searchForm]="searchForm"
                    (setPage)="setPage($event)" (onSort)="onSort($event)"></apr-table>
            </ng-container>

            <ng-container *ngIf="selectedActType == 'pi'">
                <aprPi-table #ngxDatatable [dt]="dt" [startingIndex]="startingIndex" [searchForm]="searchForm"
                    (setPage)="setPage($event)" (onSort)="onSort($event)"></aprPi-table>
            </ng-container>
        </div>
    </div>
</div>